<template>
  <b-overlay
      :show="show"
      spinner-variant="primary"
      spinner-type="grow"
      spinner-small
      rounded="sm"
    >
      <b-card title="">
      <!-- <b-card-text>App-ver.</b-card-text> -->
      <validation-observer ref="simpleRules">
        <b-form @submit.prevent>
          <b-row>
            <!-- Mode -->
            <b-col cols="12">
              <b-form-group label="Mode" label-for="v-mode">
                <validation-provider #default="{ errors }"  name="Mode" rules="required">
                  <b-form-input  id="v-mode-name" :state="errors.length > 0 ? false:null" autocomplete="off" v-model="form.text_1" placeholder="Mode" />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <!-- Number -->
            <b-col cols="12">
              <b-form-group label="Number" label-for="v-number">
                <validation-provider #default="{ errors }" name="Number" rules="required" >
                  <b-form-input id="v-number" :state="errors.length > 0 ? false:null" autocomplete="off" v-model="form.text_2" placeholder="Number" />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <!-- Priority -->
            <b-col cols="12">
              <b-form-group label="Priority" label-for="v-priority">
                <validation-provider #default="{ errors }" name="Priority" rules="required">
                  <v-select
                    v-model="form.select_3"
                    placeholder="Chose Priority" autocomplete="off" 
                    :state="errors.length > 0 ? false:null"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="title"
                    :reduce="option_2 => option_2.value"
                    :options="option_2"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <!-- OS -->
            <b-col cols="12">
              <b-form-group label="OS" label-for="v-os">
                <validation-provider #default="{ errors }" name="OS">
                  <v-select
                    v-model="form.select_4"
                    placeholder="Chose OS" autocomplete="off" 
                    :state="errors.length > 0 ? false:null"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="title"
                    :reduce="option_1 => option_1.value"
                    :options="option_1"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <!-- Min -->
            <b-col cols="12">
              <b-form-group label="Min" label-for="v-min">
                <validation-provider #default="{ errors }" name="Min" >
                  <b-form-input id="v-min" :state="errors.length > 0 ? false:null" autocomplete="off" v-model="form.text_5" placeholder="Min"/>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <!-- Max -->
            <b-col cols="12">
              <b-form-group label="Max" label-for="v-max">
                <validation-provider #default="{ errors }" name="Max">
                  <b-form-input id="v-max" :state="errors.length > 0 ? false:null" autocomplete="off" v-model="form.text_6" placeholder="Max"/>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <!-- Note -->
            <b-col cols="12">
              <b-form-group label="Note" label-for="v-note">
                <validation-provider #default="{ errors }" name="Note">
                  <b-form-input id="v-note" :state="errors.length > 0 ? false:null" autocomplete="off" v-model="form.text_7" placeholder="Note"/>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <!-- Log -->
            <b-col cols="12">
              <b-form-group label="Log" label-for="v-log">
                <validation-provider #default="{ errors }" name="Log">
                  <b-form-input id="v-log" :state="errors.length > 0 ? false:null" autocomplete="off" v-model="form.text_8" placeholder="Log"/>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <!-- submit and reset -->
            <b-col cols="12">
              <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" type="submit" variant="primary" class="mr-1" @click.prevent="validationForm"> Submit </b-button>
              <b-button v-ripple.400="'rgba(186, 191, 199, 0.15)'" type="reset" variant="outline-secondary"> Reset </b-button>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
      </b-card>
  </b-overlay>
</template>
<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { BRow, BOverlay, BCol, BFormGroup, BFormInput, BForm, BButton, BCard } from 'bootstrap-vue'
import { required } from '@validations'
import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
export default {
  components: { vSelect, BOverlay, ValidationProvider, ValidationObserver, BCard, BRow, BCol, BFormGroup, BFormInput, BForm, BButton },
  directives: { Ripple },
  data () {
    return { 
      option_1: [{ value: 'IOS', title: 'IOS' }, { value: 'ANDROID',title: 'ANDROID' }],
      option_2: [{ value: 'MAJOR',title: 'MAJOR' }, { value: 'MINOR', title: 'MINOR' }, { value: 'PATCH',title: 'PATCH' }],
      form: {id: null, text_1: '',text_2: '',select_3: '',select_4: '',text_5: '',text_6: '',text_7: '',text_8: ''},
      show: false,
      required 
    }
  },
  methods: {
    validationForm () {
      this.show = true
      this.$refs.simpleRules.validate()
      .then(success => {
        if (success) {
          const formData = this.form 
			    this.$store.dispatch('appver/formPostPut', formData)
          .then(res => {
            this.notification('Success','CheckIcon','success','You have successfully')
          }, 
          err => {
            this.show = false
            this.notification('Failed','CloseIcon','danger','You have unsuccessful')
          })
        } else {
          this.show = false
          this.notification('Failed','CloseIcon','danger','You have unsuccessful')
        }
      })
    },
    notification (a,b,c,d) {
      this.$toast({
        component: ToastificationContent,
        position: 'top-right',
        props: { title: a, icon: b, variant: c, text: d}
      })
    },
    getData (id) {
			this.$store.dispatch('appver/getById', id).then(data => {
        this.form.id = data.id
        this.form.text_1 = data.mode
        this.form.text_2 = data.number
        this.form.select_3 = data.priority
        this.form.select_4 = data.os
        this.form.text_5 = data.min
        this.form.text_6 = data.max
        this.form.text_7 = data.note
        this.form.text_8 = data.log
        this.show = false
      })
    }
  },
  mounted () {
    if (this.$route.params.id) {
      this.show = true
      this.getData(this.$route.params.id)
    }
  }
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>